import loginEvent from 'services/AuthSuite/AuthSuiteServices/events/login-event';

export default loginEvent;
